<div class="ag-flex-row-center">
  <div *ngIf="bShowButton" class="ag-box-button-bt ag-action" (click)="onExpandChange.emit()" >
    <ng-container *ngIf="!isExpanded"><mat-icon aria-hidden="false" aria-label="expand">expand_more</mat-icon><span>See more</span></ng-container>
    <ng-container *ngIf="isExpanded"><mat-icon aria-hidden="false" aria-label="loading">expand_less</mat-icon><span>See less</span></ng-container>
  </div>
  <div *ngIf="!bShowButton" >&nbsp;</div>
</div>
